import { useFeatureFlags } from '../../../services/featureFlags/hooks/useFeatureFlags';
import { ProtectedRoute } from './ProtectedRoute';

/**
 * Route only accessible in QA-Mode
 *
 * @returns Outlet if QA Mode is active, redirect to homepage otherwise
 */
export const InternalRoute = () => {
  const { Diagnostics } = useFeatureFlags();

  return <ProtectedRoute isAllowed={Diagnostics} />;
};
